import _slicedToArray from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject;

import { gql } from '@apollo/client';
import { hasMode, Modes } from '@infl-ts/util-app-config';
import { DE$ } from '@infl-ts/util-datum';
import { useToggle } from '@infl-ts/util-hooks';
import { makeDecodedQuery } from '@infl-ts/util-make-apollo-decoded';
import { logQueryError } from '@infl-ts/util-query-errors';
import { Box } from '@mui/material';
import * as DE from '@nll/datum/lib/DatumEither';
import * as Bool from 'fp-ts/boolean';
import { absurd, constant, constFalse, constTrue, flow, pipe } from 'fp-ts/function';
import * as O from 'fp-ts/Option';
import * as Pred from 'fp-ts/Predicate';
import * as t from 'io-ts';
import { useCallback } from 'react';
import { Error } from '../error';
import ChallengeFlow from './challenge-flow';
import { ChallengeOnboarding, OnboardingStatus, WelcomeMessageOnboarding } from './codecs';
import { OnboardingContext } from './context';
import WelcomeMessageFlow from './welcome-message-flow';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var useOnboardingStatus = makeDecodedQuery(gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    query OnboardingStatus {\n      onboardingStatus\n    }\n  "]))), t.type({
  onboardingStatus: OnboardingStatus
}));
export var OnboardingWorkflow = function OnboardingWorkflow(_ref) {
  var siteConfig = _ref.siteConfig,
      children = _ref.children;
  var shouldRequestOnboarding = pipe(siteConfig, DE.map(function (_ref2) {
    var consentRequired = _ref2.consentRequired,
        _ref2$configs = _ref2.configs,
        appConfig = _ref2$configs.appConfig,
        onboardingConfig = _ref2$configs.onboardingConfig;
    return pipe(appConfig, O.filter(Pred.not(hasMode(Modes.map["public"]))), O.filter(constant(consentRequired)), O.apSecond(onboardingConfig));
  }));
  var onboardingStatus = useOnboardingStatus({
    skip: pipe(shouldRequestOnboarding, DE.map(O.exists(constTrue)), DE$.getSuccessOrElse(false), Bool.BooleanAlgebra.not)
  });
  var requiresOnboardingDE = pipe(shouldRequestOnboarding, DE$.zip(onboardingStatus), DE.map(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
        onboardingConfig = _ref4[0],
        onboardingStatus = _ref4[1].onboardingStatus;

    return pipe(onboardingConfig, O.filter(function (_) {
      return onboardingStatus === OnboardingStatus.map.NOT_PASSED;
    }));
  }));
  var requiresOnboarding = useCallback(function () {
    return pipe(requiresOnboardingDE, DE.squash(constTrue, constFalse, O.match(constTrue, function (_ref5) {
      var flow = _ref5.flow;
      return WelcomeMessageOnboarding.is(flow);
    })));
  }, [requiresOnboardingDE]);

  var _useToggle = useToggle(requiresOnboarding()),
      _useToggle2 = _slicedToArray(_useToggle, 2),
      appVisibleBehindModal = _useToggle2[0],
      enableAppVisibleBehindModal = _useToggle2[1].on;

  return /*#__PURE__*/_jsxs(OnboardingContext.Provider, {
    value: {
      appVisibleBehindModal: appVisibleBehindModal,
      enableAppVisibleBehindModal: enableAppVisibleBehindModal
    },
    "data-element": "unknown",
    "data-component": "OnboardingWorkflow",
    "data-source-file": "onboarding-workflow.tsx",
    children: [pipe(requiresOnboardingDE, DE.squash(function () {
      return null;
    }, flow(logQueryError, function () {
      return /*#__PURE__*/_jsx(Error, {
        showReloadPage: true
      });
    }), O.match(function () {
      return null;
    }, function (_ref6) {
      var flow = _ref6.flow;
      return WelcomeMessageOnboarding.is(flow) ? /*#__PURE__*/_jsx(WelcomeMessageFlow, {
        onboardingWelcomeFlow: flow
      }) : ChallengeOnboarding.is(flow) ? /*#__PURE__*/_jsx(ChallengeFlow, {
        onboardingChallengeFlow: flow,
        onComplete: enableAppVisibleBehindModal
      }) : absurd(flow);
    }))), /*#__PURE__*/_jsx(Box, {
      sx: {
        display: appVisibleBehindModal ? 'block' : 'none'
      },
      "data-element": "Box",
      "data-component": "OnboardingWorkflow",
      "data-source-file": "onboarding-workflow.tsx",
      children: children
    })]
  });
};